import { Link } from "@smart/itops-sb-design-system-dom";

type HeadingProps = {
  navigate?: (target: "intake-form-builder" | "intake-settings") => void;
};

export const Heading = ({ navigate }: HeadingProps) => {
  const handleFormBuilderClick = () => {
    navigate?.("intake-form-builder");
  };

  return (
    <div className="flex items-center justify-between w-full h-[7.2rem] bg-white font-semibold text-h1 font-poppins px-16 py-[1.6rem] border-b border-neutral-100">
      <div>Intake</div>
      {navigate && (
        <div className="flex gap-medium">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link
            text="Form Settings"
            onClick={() => navigate?.("intake-settings")}
          />
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link text="Form Builder" onClick={handleFormBuilderClick} />
        </div>
      )}
    </div>
  );
};
